export default __webpack_public_path__ + "88756e4936d1f2c15ee167f88d8f929f.png";